import { useState } from "react";
import ModalCreateUpdateCategory from "../ModalCreateUpdateCategory"
import styles from "./styles.module.css";

export default function CategoryCreateButton({ collectionRef, updateTableData }) {

    const [modal, setModal] = useState(false);

    return (<>

        <div className={styles.buttonContainer}>
            <button onClick={() => { setModal(true) }} className={styles.createButton}>Nova Categoria</button>
        </div>

        {modal && <ModalCreateUpdateCategory updateTableData={updateTableData} setModal={setModal} collectionRef={collectionRef} update={false} />}

    </>)
}